import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import type { AccountJournal, JournalFormData } from "~/types/contabilidad";

import { DiarioForm } from "./DiarioForm";

interface DiarioDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  journal?: AccountJournal;
  onSubmit: (data: JournalFormData) => void;
  isLoading?: boolean;
}

export function DiarioDialog({
  open,
  onOpenChange,
  journal,
  onSubmit,
  isLoading = false,
}: DiarioDialogProps) {
  const isEditing = !!journal;

  const handleSubmit = (data: JournalFormData) => {
    onSubmit(data);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>
            {isEditing ? "Editar Diario" : "Nuevo Diario"}
          </DialogTitle>
          <DialogDescription>
            {isEditing
              ? "Modifique los datos del diario."
              : "Complete los datos para crear un nuevo diario."}
          </DialogDescription>
        </DialogHeader>

        <DiarioForm
          initialData={journal}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          submitLabel={isEditing ? "Actualizar" : "Crear Diario"}
        />
      </DialogContent>
    </Dialog>
  );
}
